export default "__VITE_ASSET__nNVp0z7o__"